/**
 * Sets or clears the Site filter and goes back to page 0. Clearing drops the key: the list APIs
 * serialize params with createSearchParams, which would send the string "undefined".
 */
export const applySiteFilter = <T extends { filterSiteId?: string; page?: number }>(filters: T, filterSiteId?: string): T => {
   const { filterSiteId: _previous, ...rest } = filters;
   return { ...rest, page: 0, ...(filterSiteId && { filterSiteId }) } as T;
};
